// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"68a8d9e6","73":"5a78617d","77":"336e1efe","179":"873f33c0","374":"989a0a9c","574":"34887e7e","607":"7349660e","651":"ef20ee8a","805":"983b5143"}[chunkId] + ".css";
};